export const CANCELLED_STYLES = {
    ROW_ACTIONS: "cancelled-styles-row-actions",
    DROP_ACTION: "cancelled-styles-drop-action",
    DROP_STYLE_CONFIRMATION_HEADER: "drop-style-confirmation-header",
    DROP_STYLE_CONFIRMATION_BUTTONS: "drop-style-confirmation-buttons",
    SORT_BUTTON: "sort-btn",
    SORT_BY_DATE_MODIFIED_DESCENDING: "sort-modifiedondesc",
    SORT_BY_STYLE_NUMBER_ASCENDING: "sort-stylenumberasc",
    SORT_BY_STYLE_NAME_ASCENDING: "sort-nameasc",
    SINGLE_STYLE_PAGE: {
        CANCELLED_UNITS_TOP: "Cancelled units",
        TOTAL_AFFECTED_ORDERS: "Total affected orders",
    },
};
